import React from "react";
import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import WhyUs from "../components/WhyUs";
import Seo from "../components/Seo";

//import Banner from "../components/Banner";
//import { Link } from "react-router-dom";
//import Services from "../components/Services";
//import FeaturedFlowers from "../components/FeaturedFlowers";

const Home = () => {
  return (
    <>
      <Seo />
      <Hero />
      <AboutUs />
      <WhyUs />
    </>
  );
};

export default Home;
